export const getHolidays = async (token, year) => {
  const myHeaders = new Headers();
  myHeaders.append("Authorization", `Bearer ${token}`);

  const qs = year ? `?year=${year}` : "";

  try {
    const response = await fetch(`${window.constants.api_url}/holidays${qs}`, {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    });
    return response.json();
  } catch (error) {
    throw new Error("Failed to fetch holidays: " + error.message);
  }
};

export const addHoliday = async (token, date, name) => {
  const myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");
  myHeaders.append("Authorization", `Bearer ${token}`);

  try {
    const response = await fetch(`${window.constants.api_url}/holidays`, {
      method: "POST",
      headers: myHeaders,
      body: JSON.stringify({ date, name }),
      redirect: "follow",
    });
    return response.json();
  } catch (error) {
    throw new Error("Failed to add holiday: " + error.message);
  }
};

export const updateHoliday = async (token, id, date, name) => {
  const myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");
  myHeaders.append("Authorization", `Bearer ${token}`);

  try {
    const response = await fetch(`${window.constants.api_url}/holidays/${id}/update`, {
      method: "POST",
      headers: myHeaders,
      body: JSON.stringify({ date, name }),
      redirect: "follow",
    });
    return response.json();
  } catch (error) {
    throw new Error("Failed to update holiday: " + error.message);
  }
};

export const deleteHoliday = async (token, id) => {
  const myHeaders = new Headers();
  myHeaders.append("Authorization", `Bearer ${token}`);

  try {
    const response = await fetch(`${window.constants.api_url}/holidays/${id}/delete`, {
      method: "POST",
      headers: myHeaders,
      redirect: "follow",
    });
    return response.json();
  } catch (error) {
    throw new Error("Failed to delete holiday: " + error.message);
  }
};
